import React from "react";
import { Dialog, Box, Typography, IconButton, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

const steps = [
  [
    "You talk, we listen",
    "Tell us about yourself and your ideal match, out loud or typed. No forms, no endless questions.",
  ],
  [
    "We build your profile",
    "We turn your words into a profile of who you are and what you're looking for. You review it and remove anything that's off.",
  ],
  [
    "We find your matches",
    "Between events, we look across everyone in the pool for people who genuinely fit you.",
  ],
  [
    "We email you",
    "When we find someone worth meeting, we'll send you an email. Come back into the app to see them.",
  ],
  [
    "You decide",
    "If you're interested, let us know. Nothing is shared and nothing happens unless you say yes.",
  ],
  [
    "We connect you",
    "If they're interested too, we introduce you both over email and you take it from there.",
  ],
];

const HowItWorks = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <Box sx={{ maxWidth: 480, mx: "auto", width: "100%", p: 3, pb: 8 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 3,
          }}
        >
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: 3,
              bgcolor: "rgba(239,82,65,0.12)",
              color: "primary.main",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <AutoAwesomeIcon sx={{ fontSize: 24 }} />
          </Box>
          <IconButton onClick={onClose} aria-label="Close">
            <CloseIcon />
          </IconButton>
        </Box>

        <Typography
          sx={{ fontSize: 26, fontWeight: 600, lineHeight: 1.2, mb: 1.5 }}
        >
          How Matchmaker works
        </Typography>

        <Typography
          sx={{ fontSize: 15, color: "text.secondary", lineHeight: 1.5, mb: 4 }}
        >
          A calmer way to meet people from our events. You talk, we do the
          looking, and we only connect you when the interest goes both ways.
        </Typography>

        <Box>
          {steps.map(([heading, body], i) => (
            <Box key={heading} sx={{ display: "flex", gap: 1.75, py: 1.25 }}>
              <Box
                sx={{
                  flexShrink: 0,
                  width: 30,
                  height: 30,
                  borderRadius: "50%",
                  bgcolor: "rgba(239,82,65,0.12)",
                  color: "primary.main",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 600,
                  fontSize: 14,
                }}
              >
                {i + 1}
              </Box>
              <Box>
                <Typography sx={{ fontSize: 16, fontWeight: 600 }}>
                  {heading}
                </Typography>
                <Typography
                  sx={{
                    fontSize: 13.5,
                    color: "text.secondary",
                    lineHeight: 1.5,
                  }}
                >
                  {body}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>

        <Button
          variant="contained"
          fullWidth
          size="large"
          onClick={onClose}
          sx={{ mt: 4 }}
        >
          Got it
        </Button>
      </Box>
    </Dialog>
  );
};

export default HowItWorks;
